var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useMemo } from 'react';
import TagChip from '../../../tagChip/components/TagChip';
import ChipsCollection from '../../../chipsCollection/ChipsCollection';
function getOrderedTags(allTags, filteringTag) {
    var order = allTags.map(function (t, idx) { return idx; });
    // move filtered tag to the front
    var filteringTagIdx = allTags.findIndex(function (c) { return c.id === (filteringTag === null || filteringTag === void 0 ? void 0 : filteringTag.id); });
    if (filteringTagIdx !== -1) {
        order = __spreadArray([filteringTagIdx], order.filter(function (idx) { return idx !== filteringTagIdx; }), true);
    }
    return order.map(function (idx) { return allTags[idx]; });
}
var TagCell = function (_a) {
    var _b = _a.value, value = _b === void 0 ? [] : _b, column = _a.column;
    var tags = useMemo(function () { return getOrderedTags(value, column.filter); }, [value, column.filter]);
    var onClickHandler = function (tag, e) {
        // prevent opening detail when user clicks on Tag
        e.stopPropagation();
        if (column.onTagClick) {
            column.onTagClick(tag);
        }
    };
    var chipRenderer = function (tag, idx) { return React.createElement(TagChip, { key: idx, label: tag.name, onClick: function (e) { return onClickHandler(tag, e); } }); };
    return (React.createElement(ChipsCollection, { items: tags, chipRenderer: chipRenderer }));
};
export default TagCell;
//# sourceMappingURL=TagCell.js.map